var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCustomTask = function SvgCustomTask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "20.167px",
    height: "18px",
    viewBox: "0 0 20.167 18",
    enableBackground: "new 0 0 20.167 18",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.263,13.561h1.121v3.318V18h-1.121H1.854h-1.12H0.733V3.073V1.951h1.121h2.382v1.122H1.854v13.806h13.408 V13.561z M15.298,2.249h-3.364V1.121V0h-1.121H6.38H5.259v1.121v2.81v1.121H6.38h3.931V3.931H6.38v-2.81h4.433v1.127V3.37h1.121 h3.364v1.121h1.121V3.37V2.249H15.298z M19.434,6.778l-1.923-1.9l-1.263,1.279l1.921,1.9L19.434,6.778z M17.626,8.605l-1.923-1.9 l-4.8,4.857l1.922,1.9L17.626,8.605z M12.334,13.897l-1.924-1.9l-0.735,2.691l0,0L12.334,13.897z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomTask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customTask.e910920e.svg";
export { ForwardRef as ReactComponent };